var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.isInHome() && 'full-height'],attrs:{"id":"app"}},[_c('v-header',{on:{"onLeftToggle":_vm.toggleLeftSidebar,"onRightToggle":_vm.toggleRightSidebar}}),_c('router-view'),_c('mission-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }